import styled from "styled-components";
import MessageBox from "./MessageBox";
import StatusBox from "./StatusBox";
import DeletedBox from "./DeletedBox";

const TimelineWrapper = styled.div`
  margin-top: 32px;
`;

const Timeline = (props) => {
  const { cmtRef, id, mode, msgs, msgsOrder, setDetailsData, status } = props;
  return (
    <TimelineWrapper>
      {msgsOrder.map((SEQ, idx, arr) => {
        return msgs[SEQ].statusMsg === "Y" ? (
          <StatusBox key={SEQ} isLastMsg={idx === arr.length - 1 ? true : false} msg={msgs[SEQ]} />
        ) : msgs[SEQ].deleted === "N" ? (
          <MessageBox
            key={SEQ}
            cmtRef={cmtRef}
            id={`tl${SEQ}`}
            isLastMsg={idx === arr.length - 1 ? true : false}
            mode={mode}
            msgs={msgs}
            questionId={id}
            SEQ={Number(SEQ)}
            setDetailsData={setDetailsData}
            status={status}
          />
        ) : (
          <DeletedBox key={SEQ} isLastMsg={idx === arr.length - 1 ? true : false} msg={msgs[SEQ]} />
        );
      })}
    </TimelineWrapper>
  );
};

export default Timeline;
